import React from "react";
import { Link } from "react-router-dom";
import style from "../../../css/BanerDistribuidora.module.css";
import { DynamicSlider } from "../DynamicSlider";

export const BannerDistribuidora = () => {
  const handleScrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" }); // Desplaza suavemente hacia arriba
  };
  return (
    <>
      <div className={style.contenedor}>
      <DynamicSlider section="Home" subSection="Banner 3" />
      </div>
    </>
  );
};
